module.exports = __webpack_public_path__ + "03_long_brown.84e0b192.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/03_long_brown.png
// module id = m4sP
// module chunks = 0